import BaseView, { DomainModel3D } from './base-view';
import logging from '../logging';
import pc from '../parametric-cache';
import { Cubby } from '../domain';
import { Mesh, BufferGeometry, Material } from 'three';
import { getParentSectionView } from '../controllers/section-controllers';

const log = logging('view');


export default class CubbyView extends BaseView {

    declare model: Cubby;

    box: Mesh;
    face: Mesh;

    constructor(model: DomainModel3D) {
        super(model);
        this.onReady.name = 'CubbyView';
        this.init();
    }

    make() {
        this.box = new Mesh(new BufferGeometry(), new Material());
        this.box.castShadow = this.box.receiveShadow = true;
        this.face = this.box.clone(true);

        this.name = 'Cubby';
        this.add(this.box);
        this.add(this.face);

        this.highlights.add(this.face);

        this.face.userData.isSelectable = true;
        this.userData.isCubby = true;
    }

    bind() {
        this.bindMaterial(this.box, this.model.boxMaterial);
        this.bindMaterial(this.face, this.model.faceMaterial);

        let changeSize = this.changeSize.bind(this);
        this.model.bind('width', changeSize);
        this.model.on('height', changeSize);
        this.model.on('depth', changeSize);
        this.model.on('thickness', changeSize);
        this.model.on('countX', changeSize);
        this.model.on('countY', changeSize);

        this.model.bind('opacity', () => {
            const castShadow = this.model.opacity == 1;
            this.box.castShadow = this.face.castShadow = castShadow;
        });
    }

    private async changeSize() {
        this.updates.queue(
            async () => [
                await pc.make('CubbyBoxes',
                    this.model.countX, this.model.countY, this.model.diagonal,
                    this.model.width, this.model.height, this.model.depth,
                    this.model.thickness),
                await pc.make('CubbyFace',
                    this.model.countX, this.model.countY, this.model.diagonal,
                    this.model.width, this.model.height, this.model.depth,
                    this.model.thickness),
            ],
            ([boxes, face]) => {
                this.box.geometry = boxes;
                this.face.geometry = face;
                this.onReady.trigger();
            }
        );
    }

}
